import { TocIdDTO } from "../toc/TocIdDTO";
import { nullToUndefined } from "../../../helper/nullToUndefined";

/**
 * @deprecated use v4
 */
export interface PlaylistItemDTO {
  tocId?: TocIdDTO;
  title?: string;
  note?: string;
}

export class PlaylistItemDTOCompanion {
  public static fromParsedJson(
    playlistItems: ReadonlyArray<PlaylistItemDTO>,
  ): ReadonlyArray<PlaylistItemDTO> {
    return playlistItems.flatMap((i: PlaylistItemDTO) => {
      const tocId = nullToUndefined(i.tocId);
      const title = nullToUndefined(i.title);
      const note = nullToUndefined(i.note);

      return { tocId, title, note };
    });
  }
}
